import React from "react";
import { BsGithub } from "react-icons/bs";

const SocialMedia = () => (
  <a
    href="https://github.com/Derssa"
    target="_blank"
    rel="noreferrer"
    className="app__social"
  >
    <div>
      <BsGithub />
    </div>
  </a>
);

export default SocialMedia;
